import { render, staticRenderFns } from "./TituloDocentesPeriodo.vue?vue&type=template&id=5ec25b76&"
import script from "./TituloDocentesPeriodo.vue?vue&type=script&lang=js&"
export * from "./TituloDocentesPeriodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports